module.exports = __webpack_public_path__ + "static/media/medium.e0cc513d.svg";